import axios from 'axios';

export const FETCH_MEMBERS = 'FETCH_MEMBERS';
export const SEARCH_FILTER = 'SEARCH_FILTER';
export const TYPE_FILTER = 'TYPE_FILTER';
export const PER_PAGE = 'PER_PAGE';
export const PAGE_NUMBER = 'PAGE_NUMBER';

export function fetchCompaniesDispatch() {
	return ( dispatch ) => {
		'use strict';
		const url = `${wpApiSettings.root}isda/v1/members`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_MEMBERS, payload: response.data
			          } );
		} );
	};
}

export function filterCompaniesByTextDispatch( searchTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_FILTER, payload: searchTerm
		          } );
	};
}

export function filterCompaniesByTypeDispatch( memberType ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: TYPE_FILTER, payload: memberType
		          } );
		dispatch( {
			          type: PAGE_NUMBER, payload: 1
		          } );
	};
}

export function limitPageCountDispatch( pageCount ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PER_PAGE, payload: pageCount
		          } );
	};
}

export function setPageNumberDispatch( pageNum ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGE_NUMBER, payload: pageNum
		          } );
	};
}